import React from 'react';
import { Grid, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AuthFooter = () => {
  const { t } = useTranslation();

  const LINKS = {
    website: 'https://www.businesskitz.com',
    contact: 'https://www.businesskitz.com/contact',
    privacyProlicy: 'https://www.businesskitz.com/privacy-policy',
    termsAndConditions: 'https://www.businesskitz.com/terms-and-conditions',
  };
  return (
    <Grid
      component='div'
      container
      className='demo-auth-footer'
      sx={{
        position: 'relative',
        bottom: 0,
        left: 0,
        width: '100%',
        paddingTop: 1,
        paddingBottom: 1,
        textAlign: 'center',
        marginTop: 3,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid component='div' container spacing={4} style={{ justifyContent: 'center' }}>
        <Grid component='div'>
          <Link
            id='authFooterSupportLink'
            href={LINKS.contact}
            target='_blank'
            rel='noreferrer noopener'
            className='text-inherit'
            sx={{ textDecoration: 'none' }}
          >
            {t('footerLinks.support')}
          </Link>
        </Grid>
        <Grid component='div'>
          <Link
            id='authFooterPrivacyPolicyLink'
            href={LINKS.privacyProlicy}
            target='_blank'
            rel='noreferrer noopener'
            className='text-inherit'
            sx={{ textDecoration: 'none' }}
          >
            {t('footerLinks.privacyPolicy')}
          </Link>
        </Grid>
        <Grid component='div'>
          <Link
            id='authFooterTermsAndConditionsLink'
            href={LINKS.termsAndConditions}
            target='_blank'
            rel='noreferrer noopener'
            className='text-inherit'
            sx={{ textDecoration: 'none' }}
          >
            {t('footerLinks.termsAndConditions')}
          </Link>
        </Grid>
      </Grid>
      <Grid component='div' sx={{ mt: 2 }}>
        <Link
          id='authFooterBusinessKitzLink'
          href={LINKS.website}
          target='_blank'
          rel='noreferrer noopener'
        >
          {t('footerLinks.businessKitz')}
        </Link>
      </Grid>
    </Grid>
  );
};

export default AuthFooter;
